import Modal from '../../shared/Modal';
import * as React from 'react';
import Select from 'react-select';
import { FormattedMessage, injectIntl, InjectedIntlProps, defineMessages } from 'react-intl';
import { useState, useEffect } from 'react';
import { sendMessage, getAccountsForDatabase } from '../../services/messages';
import { search } from '../../services/account';
import { BeatLoader } from 'react-spinners';
import DatabaseSelect from './DatabaseSelect';

interface ISendMessageModalProps {
    replyTo?: string;
    from?: string;
    to?: string;
    subject?: string;
    label?: string;
    onSave?: () => void
    raw?: boolean
}



interface IEmailOption {
    label: string;
    value: string;
}

export const parseMessageParticipant = (person) => {
    if (typeof person !== 'string') return null
    const name = person.match(/\((.*?)\)/);
    const email = `${person || ''}`.split(' ')[0]
    return { name: Array.isArray(name) && name.length > 0 ? name[0] : person, email };
}

export default injectIntl((props: InjectedIntlProps & ISendMessageModalProps) => {

    const i18nMessages = defineMessages({
        recipientRequired: {
            id: 'dash.msgs.alert.recipient',
            defaultMessage: 'Please select a recipient for your message.',
        },
        databaseRequired: {
            id: 'dash.msgs.alert.database',
            defaultMessage: 'Please select a database for your message.',
        },
        subjectRequired: {
            id: 'dash.msgs.alert.subject',
            defaultMessage: 'Please write a subject for your message',
        },
        messageRequired: {
            id: 'dash.msgs.alert.message',
            defaultMessage: 'Please write a message to send',
        },
        serverError: {
            id: 'dash.msgs.alert.server',
            defaultMessage: 'There was an error sending your message. Please try again.',
        },
        sendModalTitle: {
            id: 'dash.msgs.send.title',
            defaultMessage: 'Send Message',
        },
        sendModalReplyTitle: {
            id: 'dash.msgs.reply.title',
            defaultMessage: 'Reply to Message',
        },
        findRecipient: {
            id: 'dash.msgs.send.find',
            defaultMessage: 'Please search for a recipient',
        },
        recipientNotFound: {
            id: 'dash.msgs.send.not.found',
            defaultMessage: 'No organizations found with that name',
        },
        cancelSendMessage: {
            id: 'dash.msgs.send.cancel',
            defaultMessage: 'Cancel',
        },
        sendMessage: {
            id: 'dash.msgs.send.send',
            defaultMessage: 'Send',
        },
        from: {
            id: 'msgs.send.from.label',
            defaultMessage: 'From',
        },
        to: {
            id: 'msgs.send.to.label',
            defaultMessage: 'To',
        },
        select: {
            id: 'msgs.send.select.placeholder',
            defaultMessage: 'Select...',
        },
        typeToSearch: {
            id: 'msgs.send.select.type',
            defaultMessage: 'Type to filter...',
        },
    });

    const [to, setTo] = useState<string[] | string>([]);
    const [from, setFrom] = useState('');
    const [sending, setSending] = useState(false);
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');
    const [defaultRecipientOptions, setDefaultRecipientOptions] = useState<IEmailOption[]>([]);

    const [selectedDatabaseName, setSelectedDatabaseName] = useState<string | null>(null);
    const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);

    useEffect(() => {
        // updateDefaultRecipientOptions();
    }, []);

    const handleDatabaseChange = async (name: string) => {
        if (name) {
            const accountsResult = await getAccountsForDatabase(name);
            if (accountsResult.success && Array.isArray(accountsResult.accounts)) {
                console.warn(accountsResult.accounts);
                setSelectedDatabaseName(name);
                setDefaultRecipientOptions(
                    accountsResult.accounts
                        .filter((x) => x.address !== props.from)
                        .map((x) => ({ label: x.name, value: x.address }))
                );
            } else if (!accountsResult.success) {
                alert(
                    'There was an issue loading the selected database. Please reload the page and try agian.'
                );
            }
        }
    };

    const renderDatabaseSelect = () => {
        if (props.to) return null;
        return (
            <div className="py-3">
                {/* <FormattedMessage id="dash.page.add.err.nosub" defaultMessage="You must be a part of a database to start a conversation!">
                    {(noDatabasesMessage: string) => (
                        <FormattedMessage id="dash.msgs.send.dbselect" defaultMessage="Select a Database to Start a Conversation.">
                            {(defaultMessage: string) => <DatabaseSelect
                                errorMessage={hasSubmitted && !selectedDatabaseName && <FormattedMessage id="dash.msgs.send.dbselect.req" defaultMessage="You must select a database to start a conversation." />}
                                selectedDatabaseName={selectedDatabaseName}
                                currentModalId={`newMessageModal`}
                                onChange={handleDatabaseChange}
                                defaultMessage={defaultMessage}
                                canCreate={false}
                                noDatabasesMessage={noDatabasesMessage} />}
                        </FormattedMessage>
                    )
                    }
                </FormattedMessage> */}
                <DatabaseSelect
                    errorMessage={
                        !selectedDatabaseName &&
                        hasSubmitted &&
                        'You must select a database to start a conversation.'
                    }
                    selectedDatabaseName={selectedDatabaseName}
                    currentModalId={`newMessageModal`}
                    onChange={handleDatabaseChange}
                    defaultMessage={'Select a Database to Start a Conversation.'}
                    canCreate={false}
                    noDatabasesMessage={'You must be a part of a database to start a conversation!'}
                />
            </div>
        );
    };

    // const updateDefaultRecipientOptions = async () => {
    //     const results = await search('*', 5);
    //     if (results.results === undefined) return;
    //     const options = results.results.map(result => ({
    //         value: result.email,
    //         label: result.organization,
    //     }));
    //     setDefaultRecipientOptions(options);
    // };

    const closeModal = () => {
        $('#newMessageModal').modal('hide');
    };

    const PARENS_CONTENT_REGEX = /\((.*?)\)/;

    const send = async () => {
        setHasSubmitted(true);
        setSending(true);
        if (
            !(Array.isArray(to) ? to : []).length &&
            !Array.isArray(props.to) &&
            !(props.to || '').length
        ) {
            alert(props.intl.formatMessage(i18nMessages.recipientRequired));
            return;
        }
        if (!selectedDatabaseName && !props.to) {
            alert(props.intl.formatMessage(i18nMessages.databaseRequired));
            return;
        }
        if (!(subject || props.subject)) {
            alert(props.intl.formatMessage(i18nMessages.subjectRequired));
            return;
        }
        if (!message) {
            alert(props.intl.formatMessage(i18nMessages.messageRequired));
            return;
        }
        const replyToDatabase = props?.replyTo && !props?.replyTo.includes("@") && PARENS_CONTENT_REGEX.test(props?.replyTo)
        const propsTo = parseMessageParticipant(props?.to || to)
        const toAddresses = propsTo ? [propsTo?.email] : to;

        for (const toAddress of toAddresses) {
            const f = parseMessageParticipant(from || props.from || '');
            try {
                const req = await sendMessage(
                    toAddress === '*' && selectedDatabaseName ? [selectedDatabaseName] : [toAddress],
                    f && f.email ? f.email : from || props.from || '',
                    selectedDatabaseName ?? "",
                    props.replyTo || '',
                    subject || props.subject || 'RE:',
                    message
                );
                if (!req.success) {
                    alert(props.intl.formatMessage(i18nMessages.serverError));
                    setSending(false);
                    return;
                }
            } catch (ex) {
                console.error('Exception thrown while sending message', ex);
            }
        }
        setTo([]);
        setSending(false);
        setSelectedDatabaseName(null);
        // setFrom('');
        setDefaultRecipientOptions([]);
        setSubject('');
        setMessage('');
        setHasSubmitted(false);
        if (props.onSave) props.onSave()
        closeModal();
    };

    const newMessageActionButtons = () => [
        <button
            type="button"
            className="primary"
            key="send-button"
            onClick={send}
            disabled={
                (!selectedDatabaseName && !(props.to || '').length && !to.length) ||
                !(subject || props.subject) ||
                !message ||
                sending
            }>
            {sending ? (
                <BeatLoader size={12} loading={sending} color="#ffffff" />
            ) : (
                props.intl.formatMessage(i18nMessages.sendMessage)
            )}
        </button>,
    ];

    const loadRecipientOptions = async (inputValue: string, callback: any) => {
        const results = await search(inputValue);
        if (results.results === undefined) return;
        const options = results.results.map((result) => ({
            value: result.email,
            label: result.organization,
        }));
        callback(options);
    };

    const renderContent = () => {
        return (
            <React.Fragment>
                {(selectedDatabaseName || props.to) && (
                    <p className="text-muted font-weight-light">
                        <FormattedMessage
                            id="dash.msgs.send.help"
                            defaultMessage={`Messages are automatically saved in your Message History. To reply, write a message below and click Send.`}
                        />
                    </p>
                )}
                {renderDatabaseSelect()}
                {(selectedDatabaseName || props.to) && renderFormContent()}
            </React.Fragment>
        );
    };

    const renderFormContent = () => {
        let toField = (
            <div className="form-group">
                <label htmlFor="recipients">{props.intl.formatMessage(i18nMessages.to)}</label>
                <Select
                    cacheOptions
                    id="recipients"
                    // loadOptions={loadRecipientOptions}
                    options={[
                        { label: 'All Partners in Database', value: '*' },
                        ...defaultRecipientOptions,
                    ]}
                    isMulti
                    noOptionsMessage={({ inputValue }) =>
                        inputValue.length < 3
                            ? props.intl.formatMessage(i18nMessages.findRecipient)
                            : props.intl.formatMessage(i18nMessages.recipientNotFound)
                    }
                    // getValue={(x: any) => console.warn(x)}
                    onChange={(n: any) => setTo(n.map((e: any) => e.value))}
                    placeholder={props.intl.formatMessage(i18nMessages.typeToSearch)}
                />
            </div>
        );

        if (props.to) {
            toField = (
                <div className="form-group">
                    <label htmlFor="recipients">{props.intl.formatMessage(i18nMessages.to)}</label>
                    <input
                        className="form-control"
                        id="recipients"
                        value={props.label || props.to}
                        disabled
                    />
                </div>
            );
        }
        return (
            <React.Fragment>
                {toField}
                <div className="form-group">
                    <FormattedMessage id="dash.msgs.send.subject.label" defaultMessage="Subject">
                        {(txt: string) => <label htmlFor="subject">{txt}</label>}
                    </FormattedMessage>
                    <input
                        className="form-control"
                        id="subject"
                        value={props.subject || subject}
                        disabled={!!props.subject}
                        onChange={(e: React.FormEvent<HTMLInputElement>) =>
                            setSubject(e.currentTarget.value)
                        }
                    />
                </div>
                <div className="form-group">
                    <FormattedMessage id="dash.msgs.send.msg.label" defaultMessage="Message">
                        {(txt: string) => <label htmlFor="message">{txt}</label>}
                    </FormattedMessage>
                    <textarea
                        className="form-control"
                        id="message"
                        rows={3}
                        value={message}
                        onChange={(e) => setMessage(e.currentTarget.value)}
                    />
                </div>
            </React.Fragment>
        );
    };

    // Need to confirm if there is a real use case for having sender options
    // other than yourself and your current organization
    // const loadSenderOptions = async (inputValue: string, callback: any) => {
    //     const req = await getAccountDetails();
    //     if (!req.success) return;
    //     const accountDetails = req.accountDetails;
    //     if (accountDetails === undefined) return;
    //     const options = [
    //         {
    //             value: accountDetails.organization.email,
    //             label: accountDetails.organization.orgName,
    //         },
    //         {
    //             value: accountDetails.owner.email,
    //             label: accountDetails.owner.fullName,
    //         },
    //     ];
    //     callback(options);
    // };

    const modalTitle = props.replyTo
        ? props.intl.formatMessage(i18nMessages.sendModalReplyTitle)
        : props.intl.formatMessage(i18nMessages.sendModalTitle);

    return (
        <React.Fragment>
            {!props.raw ? <Modal
                id="newMessageModal"
                title={modalTitle}
                actionButtons={newMessageActionButtons()}>
                <form>{renderContent()}</form>
            </Modal> : <form>{renderContent()}{newMessageActionButtons()}</form>}
        </React.Fragment>
    );
});



// WEBPACK FOOTER //
// ./src/client/shared/SendMessageModal.tsx